import { GroupRange, ITripStatsSum } from '../store/StatsStore';
import { MaterialStatsTableTBody } from './MaterialStatsTableTBody';
import * as React from 'react';

export class MaterialStatsTable extends React.Component<{
    stats: Record<string, ITripStatsSum>;
    groupedBy: GroupRange;
}> {
    render() {
        const { groupedBy, stats } = this.props;
        const timeGroups = Object.values(stats);

        return (
            <>
                <table className='simple-table stats-table bold-last-row'>
                    <thead>
                        <tr>
                            {groupedBy != 'all' && <th>{__('general.date')}</th>}
                            <th>{__('trucks.trips.table_material')}</th>
                            <th>{__('trucks.m3_loose')}</th>
                            <th>{__('trucks.m3_solid')}</th>
                            <th>{__('trucks.tons')}</th>
                            <th>{__('trucks.pieces')}</th>
                            <th className='no-break-text'>{__('trucks.trips.table_ttime')}</th>
                            <th className='no-break-text'>{__('trucks.trips.trips_title')}</th>
                            <th className='no-break-text'>{__('trucks.trips.table_distance')}</th>
                            <th className='no-break-text' title='Average distance (total distance / trips count)'>
                                {__('trucks.trips.average_distance')}
                            </th>
                        </tr>
                    </thead>

                    {timeGroups.map((timeGroup, di) => (
                        <MaterialStatsTableTBody key={di} stats={timeGroup} groupedBy={this.props.groupedBy} />
                    ))}
                </table>

                {(!timeGroups || timeGroups.length === 0) && (
                    <div className='text-center' style={{ fontSize: 15, padding: '1em' }}>
                        {__('general.no_activity')}
                    </div>
                )}
            </>
        );
    }
}
